import React, { useEffect, useState } from "react";
import {
  Box,
  Heading,
  Text,
  Button,
  Image,
  Flex,
  SimpleGrid,
  Container,
  Badge,
  HStack,
  VStack,
  Icon,
  Divider,
} from "@chakra-ui/react";
import { FiCheck, FiArrowRight, FiShield, FiCpu, FiDatabase, FiFileText } from "react-icons/fi";
import { apiUrl } from "../ApiUrl/ApiUrl";
import Slider from "react-slick";
import { Link, NavLink } from "react-router-dom";

function SupremeAI() {
  const [fashion, setFashion] = useState([]);
  const [data, setData] = useState("");
  const [data2, setData2] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const getFashion = () => {
    setLoading(true);
    fetch(`${apiUrl}/public/allbooks`)
      .then((res) => res.json())
      .then((res) => setFashion(res))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  };

  const getPrice = () => {
    fetch(`${apiUrl}/public/singleBook?bid=543`)
      .then((res) => res.json())
      .then((res) => setData(res))
      .catch(() => setError(true));
  };

  const getPrice2 = () => {
    fetch(`${apiUrl}/public/singleBook?bid=544`)
      .then((res) => res.json())
      .then((res) => setData2(res))
      .catch(() => setError(true));
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getFashion();
    getPrice();
    getPrice2();
  }, []);

  return (
    <Box bg="#F8FAFC" minH="100vh" pb={16}>
      {/* SaaS Hero Header */}
      <Box
        bgGradient="linear(to-b, #0B132B, #162237)"
        color="white"
        py={{ base: 12, md: 16 }}
        px={{ base: 4, md: 8 }}
        textAlign="center"
      >
        <Container maxW="900px">
          <Badge
            bg="whiteAlpha.200"
            color="#EAB308"
            px={3}
            py={1}
            rounded="full"
            fontSize="xs"
            fontWeight="bold"
            letterSpacing="wider"
            mb={4}
          >
            VIKAS PUBLICATIONS • OFFICIAL DISTRIBUTOR
          </Badge>

          <Heading
            as="h1"
            fontSize={{ base: "30px", md: "46px" }}
            fontWeight="extrabold"
            letterSpacing="tight"
            mb={3}
          >
            Supreme Today AI
          </Heading>

          <Text
            fontSize={{ base: "sm", md: "lg" }}
            color="gray.300"
            maxW="750px"
            mx="auto"
            lineHeight="tall"
          >
            The single largest and most comprehensive digital repository of Indian case law, statutes, and precedent analysis powered by cutting-edge legal intelligence.
          </Text>
        </Container>
      </Box>

      {/* Main Content: Plans & Product Showcase */}
      <Container maxW="1200px" mt={-8} px={{ base: 3, md: 6 }}>
        <Box
          bg="white"
          rounded="2xl"
          border="1px solid"
          borderColor="gray.200"
          shadow="sm"
          p={{ base: 5, md: 8 }}
        >
          <Flex direction={{ base: "column", lg: "row" }} gap={{ base: 8, lg: 10 }} align="center">
            {/* Left: Pricing Editions */}
            <Box w={{ base: "100%", lg: "55%" }}>
              <HStack spacing={2} mb={1}>
                <Text fontSize="xs" fontWeight="bold" color="#EAB308" textTransform="uppercase" letterSpacing="wider">
                  Flexible Subscriptions
                </Text>
              </HStack>
              <Heading size="lg" color="#162237" fontWeight="bold" mb={6}>
                Select Your Access Edition
              </Heading>

              <VStack spacing={5} align="stretch">
                {/* Plan 1: Library Edition */}
                <Box
                  p={{ base: 4, md: 5 }}
                  rounded="xl"
                  border="2px solid"
                  borderColor="#162237"
                  bg="white"
                  shadow="sm"
                  position="relative"
                >
                  <Badge
                    position="absolute"
                    top={-3}
                    right={4}
                    bg="#162237"
                    color="#EAB308"
                    fontSize="10px"
                    px={2.5}
                    py={0.5}
                    rounded="full"
                    fontWeight="bold"
                  >
                    MOST COMPREHENSIVE
                  </Badge>

                  <Flex justify="space-between" align="flex-start" wrap="wrap" gap={2}>
                    <Box>
                      <Heading size="md" color="#162237">
                        Library Edition
                      </Heading>
                      <Text fontSize="xs" color="gray.600" mt={1}>
                        Supreme Court, All High Courts, Tribunals, Privy Council & Foreign Precedents
                      </Text>
                    </Box>

                    <Box textAlign={{ base: "left", sm: "right" }}>
                      <HStack spacing={2} align="baseline">
                        <Text fontSize="xl" fontWeight="extrabold" color="#162237">
                          ₹{data.descprice || "—"}
                        </Text>
                        {data.originalprice && (
                          <Text fontSize="xs" color="gray.400" as="del">
                            ₹{data.originalprice}
                          </Text>
                        )}
                      </HStack>
                      <Text fontSize="10px" color="gray.500">+ 18% GST Applicable</Text>
                    </Box>
                  </Flex>

                  <HStack spacing={3} mt={3} pt={3} borderTop="1px solid" borderColor="gray.100" fontSize="xs" color="gray.600">
                    <HStack spacing={1}>
                      <Icon as={FiCheck} color="green.600" boxSize={3.5} />
                      <Text>All Tribunals & Courts</Text>
                    </HStack>
                    <HStack spacing={1}>
                      <Icon as={FiCheck} color="green.600" boxSize={3.5} />
                      <Text>Overruled Flags</Text>
                    </HStack>
                    <HStack spacing={1}>
                      <Icon as={FiCheck} color="green.600" boxSize={3.5} />
                      <Text>AI Search</Text>
                    </HStack>
                  </HStack>

                  <Link to="/products/view/543">
                    <Button
                      mt={4}
                      w="100%"
                      size="sm"
                      bg="#162237"
                      color="white"
                      _hover={{ bg: "#0F172A" }}
                      rounded="lg"
                      rightIcon={<FiArrowRight />}
                    >
                      Subscribe to Library Edition
                    </Button>
                  </Link>
                </Box>

                {/* Plan 2: State Edition */}
                <Box
                  p={{ base: 4, md: 5 }}
                  rounded="xl"
                  border="1px solid"
                  borderColor="gray.200"
                  bg="white"
                  shadow="xs"
                >
                  <Flex justify="space-between" align="flex-start" wrap="wrap" gap={2}>
                    <Box>
                      <Heading size="md" color="#162237">
                        State Edition
                      </Heading>
                      <Text fontSize="xs" color="gray.600" mt={1}>
                        Supreme Court of India & Your Dedicated State High Court
                      </Text>
                    </Box>

                    <Box textAlign={{ base: "left", sm: "right" }}>
                      <HStack spacing={2} align="baseline">
                        <Text fontSize="xl" fontWeight="extrabold" color="#162237">
                          ₹{data2.descprice || "—"}
                        </Text>
                        {data2.originalprice && (
                          <Text fontSize="xs" color="gray.400" as="del">
                            ₹{data2.originalprice}
                          </Text>
                        )}
                      </HStack>
                      <Text fontSize="10px" color="gray.500">+ 18% GST Applicable</Text>
                    </Box>
                  </Flex>

                  <HStack spacing={3} mt={3} pt={3} borderTop="1px solid" borderColor="gray.100" fontSize="xs" color="gray.600">
                    <HStack spacing={1}>
                      <Icon as={FiCheck} color="green.600" boxSize={3.5} />
                      <Text>Supreme Court</Text>
                    </HStack>
                    <HStack spacing={1}>
                      <Icon as={FiCheck} color="green.600" boxSize={3.5} />
                      <Text>Home State High Court</Text>
                    </HStack>
                    <HStack spacing={1}>
                      <Icon as={FiCheck} color="green.600" boxSize={3.5} />
                      <Text>Fast Citation Search</Text>
                    </HStack>
                  </HStack>

                  <Link to="/products/view/544">
                    <Button
                      mt={4}
                      w="100%"
                      size="sm"
                      variant="outline"
                      colorScheme="navy"
                      borderColor="#162237"
                      rounded="lg"
                      rightIcon={<FiArrowRight />}
                    >
                      Subscribe to State Edition
                    </Button>
                  </Link>
                </Box>
              </VStack>
            </Box>

            {/* Right: Product Banner Image */}
            <Box w={{ base: "100%", lg: "45%" }} textAlign="center">
              <Box
                p={4}
                bg="#F1F5F9"
                rounded="2xl"
                border="1px solid"
                borderColor="gray.200"
              >
                <Image
                  src="./supremeai.jpeg"
                  alt="Supreme Today AI Interface"
                  maxH="380px"
                  mx="auto"
                  objectFit="contain"
                  rounded="xl"
                  fallbackSrc="https://navneetlawstudio.com/logo.png"
                />
              </Box>
            </Box>
          </Flex>
        </Box>

        {/* Feature Highlights Grid */}
        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={6} mt={8}>
          <Box bg="white" p={5} rounded="xl" border="1px solid" borderColor="gray.200" shadow="xs">
            <Flex w="40px" h="40px" rounded="lg" bg="blue.50" color="#162237" align="center" justify="center" mb={3} fontSize="18px">
              <FiCpu />
            </Flex>
            <Text fontSize="sm" fontWeight="bold" color="gray.800" mb={1}>
              AI Precedent Search
            </Text>
            <Text fontSize="xs" color="gray.600" lineHeight="tall">
              Type full facts or query phrases in natural English to instantly discover analogous bench rulings and binding ratio decidendi.
            </Text>
          </Box>

          <Box bg="white" p={5} rounded="xl" border="1px solid" borderColor="gray.200" shadow="xs">
            <Flex w="40px" h="40px" rounded="lg" bg="purple.50" color="purple.700" align="center" justify="center" mb={3} fontSize="18px">
              <FiDatabase />
            </Flex>
            <Text fontSize="sm" fontWeight="bold" color="gray.800" mb={1}>
              Exhaustive Law Coverage
            </Text>
            <Text fontSize="xs" color="gray.600" lineHeight="tall">
              Spans Supreme Court judgments since 1950, Privy Council cases from 1836, and every functional High Court in India.
            </Text>
          </Box>

          <Box bg="white" p={5} rounded="xl" border="1px solid" borderColor="gray.200" shadow="xs">
            <Flex w="40px" h="40px" rounded="lg" bg="green.50" color="green.700" align="center" justify="center" mb={3} fontSize="18px">
              <FiShield />
            </Flex>
            <Text fontSize="sm" fontWeight="bold" color="gray.800" mb={1}>
              Certified Authentic Citations
            </Text>
            <Text fontSize="xs" color="gray.600" lineHeight="tall">
              Cross-referenced with AIR, SCC, SCR, Scale, and regional law reports for reliable courtroom submission.
            </Text>
          </Box>
        </SimpleGrid>

        {/* Recommended Softwares Slider */}
        <Box mt={12}>
          <Flex justify="space-between" align="center" mb={4}>
            <Box>
              <Text fontSize="xs" fontWeight="bold" color="gray.500" textTransform="uppercase" letterSpacing="wider">
                Explore More Tools
              </Text>
              <Heading size="md" color="#162237">
                Recommended Legal Softwares
              </Heading>
            </Box>
            <Link to="/software">
              <Button size="xs" variant="outline" colorScheme="navy">
                View All Softwares
              </Button>
            </Link>
          </Flex>

          <Box
            p={4}
            bg="white"
            rounded="xl"
            border="1px solid"
            borderColor="gray.200"
            shadow="xs"
          >
            <Slider {...settings}>
              {fashion
                .filter((item) => item.maincatname === "software" || item.subcatname === "software")
                .map((item) => (
                  <Box key={item.id} p={2}>
                    <NavLink to={`/products/view/${item.id}`}>
                      <Box
                        bg="gray.50"
                        rounded="lg"
                        border="1px solid"
                        borderColor="gray.200"
                        p={3}
                        textAlign="center"
                        _hover={{ borderColor: "#162237", bg: "white", shadow: "sm" }}
                        transition="all 0.2s"
                        h="100%"
                      >
                        <Image
                          src={item.imagePath}
                          alt={item.booktitle}
                          h="120px"
                          mx="auto"
                          objectFit="contain"
                          fallbackSrc="https://navneetlawstudio.com/logo.png"
                        />
                        <Text
                          fontSize="xs"
                          fontWeight="bold"
                          color="gray.800"
                          mt={2}
                          noOfLines={2}
                          minH="32px"
                        >
                          {item.booktitle}
                        </Text>
                        <HStack justify="center" spacing={2} mt={1}>
                          <Text fontSize="xs" fontWeight="bold" color="#162237">
                            ₹{item.descprice}
                          </Text>
                          {item.originalprice && (
                            <Text fontSize="10px" color="gray.400" as="del">
                              ₹{item.originalprice}
                            </Text>
                          )}
                        </HStack>
                      </Box>
                    </NavLink>
                  </Box>
                ))}
            </Slider>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default SupremeAI;
